import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setLevel2Properties,
  getL1SheetProperty,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useGetFiltersOptionsMutation } from "../../../features/reduxworkbook/dataApiSlice";
import CustomSelectBox from "./CustomSelectBox";
import { cityArray, stateArray } from "./citynStateArray";
import SelectBox from "../../../features/reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import { FaXmark } from "react-icons/fa6";
import LoadingIndicator from "../../BasicComponents/LoadingIndicator";
const areaUnit = [
  { label: "City", value: "City" },
  { label: "State", value: "State" },
];

const getAvailableAreas = async (selectedAreaUnit) => {
  switch (selectedAreaUnit) {
    case "State":
      const indianStates = stateArray;
      return indianStates;
    case "City":
      const indianCities = cityArray;
      return indianCities;
    default:
      return []; // Return an empty array in case of error
  }
};

function isValidViztaArea(
  areas,
  validValues,
  limit = 20,
  requiredValidCount = 5
) {
  if (validValues.length === 0) return true;
  // console.log(areas, validValues);
  let validCount = 0; // Counter for valid, non-empty viztaArea arrays
  let blankCount = 0;
  const loopLimit = Math.min(limit, areas.length);
  const passLimit = Math.min(limit, areas.length * 0.5);
  // Check up to the specified limit or total areas, whichever is smaller
  for (let i = 0; i < Math.min(limit, areas.length); i++) {
    const { viztaArea } = areas[i];
    // Skip empty viztaArea arrays
    if (viztaArea.length === 0) {
      blankCount++;
      continue;
    }
    if (blankCount > 15) {
      // console.log("false due to blanks");
      return false;
    }

    const isValid = viztaArea.every((value) => validValues.includes(value));
    // console.log(isValid);
    if (isValid) {
      validCount++; // Increment count if viztaArea is valid and non-empty
      // console.log(validCount);
      // If we've reached the required number of valid entries, return true
      if (validCount >= passLimit) {
        return true;
      }
    }
  }
  // If fewer than the required number of valid viztaAreas are found, return false
  // console.log("false due to last");
  return false;
}

const reviseExistingAreas = (
  prevSelectorObject,
  availableAreas,
  selectedAreaUnit
) => {
  // Get set of Vizta Areas
  const areaMappingSyncWithUnit = isValidViztaArea(
    prevSelectorObject,
    availableAreas
  );
  // console.log(
  //   areaMappingSyncWithUnit,
  //   availableAreas,
  //   prevSelectorObject,
  //   selectedAreaUnit
  // );
  if (areaMappingSyncWithUnit) {
    return prevSelectorObject;
  } else {
    const refreshedArray = prevSelectorObject.map((item) => ({
      ...item,
      viztaArea: availableAreas.filter((option) => option === item.userArea),
    }));
    // console.log(refreshedArray);
    return refreshedArray;
  }
};

function AreaMapping(props) {
  const [selectedCountry, setSelectedCountry] = useState("India");
  const [selectedAreaUnit, setSelectedAreaUnit] = useState("State");
  // console.log(selectedAreaUnit);
  const [countries, setCountries] = useState(["India"]);
  const [availableAreas, setAvailableAreas] = useState([]);
  // console.log(availableAreas);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const { Sheetid, closeModal, fieldForGeogrophy, dataSourceID } = props;
  const { columnName } = fieldForGeogrophy;
  const [selectorObject, setSelectorObject] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    const fetchAreas = async () => {
      try {
        const result = await getAvailableAreas(selectedAreaUnit, {
          signal: controller.signal,
        });
        setAvailableAreas(result);
      } catch (error) {
        if (error.name === "AbortError") {
          // Handle fetch being aborted
          // console.log("Fetch aborted");
        } else {
          console.error("Fetch error:", error);
        }
      }
    };

    fetchAreas();

    // Cleanup function to abort previous fetches
    return () => controller.abort();
  }, [selectedAreaUnit]);

  const refreshedArray = selectorObject.map((item) => ({
    ...item,
    viztaArea: availableAreas.filter((option) => option === item.userArea),
  }));
  // console.log(refreshedArray);

  const dispatch = useDispatch();
  const customization = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  // console.log(customization);

  const { rows = [], selectedAreaUnit: incomingSelectedAreaUnit } =
    customization || {};

  useEffect(() => {
    // console.log(rows, customization);
    if (rows.length) {
      setSelectorObject(rows);
    }
    if (incomingSelectedAreaUnit) {
      setSelectedAreaUnit(incomingSelectedAreaUnit);
    }
  }, [rows, incomingSelectedAreaUnit]);

  useEffect(() => {
    // console.log(selectedAreaUnit);
    // console.log(availableAreas);
  }, [availableAreas]);

  const [getFiltersOptions, { data, isError, error, isLoading, isSuccess }] =
    useGetFiltersOptionsMutation({
      fixedCacheKey: columnName,
    });

  useEffect(() => {
    const requestBody = {
      databaseID: dataSourceID,
      columns: [{ name: columnName }],
    };
    getFiltersOptions({ filterBody: requestBody, calledFrom: "areamapping" });
  }, [dataSourceID, columnName]);

  useEffect(() => {
    // console.log(isSuccess, data);
    // console.log(selectedAreaUnit);

    if (isSuccess && data && data[columnName]) {
      // console.log(availableAreas, selectorObject);
      // console.log("setting from data");
      setSelectorObject((prevSelectorObject) => {
        const existingAreas = prevSelectorObject.map((item) => item.userArea);
        const newEntries = data[columnName]
          .filter((area) => !existingAreas.includes(area))
          .map((area) => ({
            userArea: area,
            viztaArea: availableAreas.filter((option) => option === area),
          }));
        const revisedExistingAreas = reviseExistingAreas(
          prevSelectorObject,
          availableAreas,
          selectedAreaUnit
        );
        // console.log(revisedExistingAreas);
        return [...revisedExistingAreas, ...newEntries];
      });
    }
  }, [isSuccess, data, columnName, availableAreas, selectedAreaUnit]);

  const handleCountryClick = () => {
    setShowCountryDropdown((prev) => !prev);
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setShowCountryDropdown(false);
  };

  const handleDropdownChange = (item, value, index) => {
    // console.log("setting from dropdownChange");
    setSelectorObject((prevSelectorObject) =>
      prevSelectorObject.map((obj) =>
        obj.userArea === item.userArea ? { ...obj, viztaArea: value } : obj
      )
    );
  };

  const handleAreaUnitChange = (event) => {
    const value = event.target.value;
    // console.log(value);

    setSelectedAreaUnit(value);
  };
  const handleApply = () => {
    dispatch(
      setLevel2Properties({
        parentKey: "customization",
        reduxKey: "selectedAreaUnit",
        Sheetid: Sheetid,
        value: selectedAreaUnit,
        index: 0,
      })
    );
    dispatch(
      setLevel2Properties({
        parentKey: "customization",
        reduxKey: "rows",
        Sheetid: Sheetid,
        value: selectorObject,
        index: 0,
      })
    );
    setShowModal(false);
    closeModal();
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleApply(); // Call your function here
    }
  };

  if (!showModal) return null;
  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      <div className="flex flex-col items-start justify-start h-[60%] bg-white rounded shadow-lg w-[27%]">
        <header className="flex items-center justify-between w-full p-1 h-[10%]">
          Geographical Area
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="flex items-center justify-between w-full p-1 h-[10%]">
          <div className="w-[50%] flex items-center justify-start gap-1">
            <span className="font-medium">Country : </span>
            India
          </div>
          <div className="w-[50%] flex items-center justify-start gap-1">
            <span className="font-medium">Area Unit : </span>
            <SelectBox
              value={selectedAreaUnit}
              onChange={handleAreaUnitChange}
              optionsArray={areaUnit}
            />
          </div>
        </section>
        <section className="h-[70%] overflow-hidden overflow-y-auto w-full p-1">
          <table className="w-full border-collapse bg-white shadow rounded-lg h-full">
            <thead>
              <tr className="bg-gray-200">
                <th className="w-1/2 border border-gray-300 sticky top-0 bg-gray-200 z-10 font-medium">
                  Data
                </th>
                <th className="w-1/2 border border-gray-300 sticky top-0 bg-gray-200 z-10 font-medium">
                  Vizta
                </th>
              </tr>
            </thead>
            {isLoading && <LoadingIndicator />}
            {isError && <p>Error: {error?.message || "An error occurred"}</p>}
            {isSuccess && (
              <tbody className="w-full">
                {selectorObject.map((item, index) => (
                  <tr key={item.userArea} className="w-full">
                    <td className="border border-gray-300">{item.userArea}</td>
                    <td className="border border-gray-300 w-full">
                      <CustomSelectBox
                        item={item} // Pass the current item
                        index={index} // Pass the current index
                        dropdownOptions={availableAreas}
                        handleDropdownChange={handleDropdownChange} // Pass the change handler
                        selectedOptions={item.viztaArea}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </section>

        {/* Fixed button section at the bottom */}
        <div className="w-full flex items-center justify-end p-1 h-[10%] gap-1">
          <button
            onClick={closeModal}
            className="py-1 px-4 rounded border border-gray-400"
          >
            Close
          </button>
          <button
            onClick={handleApply}
            className="bg-blue-950 text-white py-1 px-4 rounded"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}

export default AreaMapping;
